/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInTransferInitOutput
 */
export interface MoneyInTransferInitOutput {
    /**
     * 
     * @type {string}
     * @memberof MoneyInTransferInitOutput
     */
    redirectUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof MoneyInTransferInitOutput
     */
    id?: number;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInTransferInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInTransferInitOutput interface.
 */
export function instanceOfMoneyInTransferInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInTransferInitOutputFromJSON(json: any): MoneyInTransferInitOutput {
    return MoneyInTransferInitOutputFromJSONTyped(json, false);
}

export function MoneyInTransferInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInTransferInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInTransferInitOutputToJSON(value?: MoneyInTransferInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirectUrl': value.redirectUrl,
        'id': value.id,
        'error': value.error,
    };
}

